// extracted by mini-css-extract-plugin
export default {"social-login":"SocialLogin_social-login__CtECH","social-login__item":"SocialLogin_social-login__item__HE0A+","social-login__loader":"SocialLogin_social-login__loader__spwRs"};